$(document).ready(function(){
  
  $(".main-menu--wrapper .menu-toggle").click(function(){
    $(".blinix-drawer-menu, .blinix-overlay").toggleClass("blinix-active");
});

    
  $(".header-mobile__wrapper  .mobileMenu-toggle").click(function(){
    $(".mobile-drawer-menu, .blinix-overlay").toggleClass("blinix-active");
});

  
  // $(".template-product .header-logo .header__heading .header__heading-link ").html(`<img src="https://cdn.shopify.com/s/files/1/0842/4334/9804/files/19.png" class="header__heading-logo logo__main w-100 h-auto ver-alg-mid d-inline-block" alt="Spotless Store Online" width="220" height="220">`)
  // $(".template-product .header-mobile__wrapper .header-mobile__item .header__heading-link ").html(`<img src="https://cdn.shopify.com/s/files/1/0842/4334/9804/files/19.png" class="header__heading-logo logo__main w-100 h-auto ver-alg-mid d-inline-block" alt="Spotless Store Online" width="220" height="220">`)

  // $(".template-page .header-logo .header__heading .header__heading-link ").html(`<img src="https://cdn.shopify.com/s/files/1/0842/4334/9804/files/19.png" class="header__heading-logo logo__main w-100 h-auto ver-alg-mid d-inline-block" alt="Spotless Store Online" width="220" height="220">`)
    // $(".template-page .header-mobile__wrapper .header-mobile__item .header__heading-link").html(`<img src="https://cdn.shopify.com/s/files/1/0842/4334/9804/files/19.png" class="header__heading-logo logo__main w-100 h-auto ver-alg-mid d-inline-block" alt="Spotless Store Online" width="220" height="220">`)

  // $(".template-cart .header-logo .header__heading .header__heading-link ").html(`<img src="https://cdn.shopify.com/s/files/1/0842/4334/9804/files/19.png" class="header__heading-logo logo__main w-100 h-auto ver-alg-mid d-inline-block" alt="Spotless Store Online" width="220" height="220">`)
  // $(".template-cart .header-mobile__wrapper .header-mobile__item .header__heading-link ").html(`<img src="https://cdn.shopify.com/s/files/1/0842/4334/9804/files/19.png" class="header__heading-logo logo__main w-100 h-auto ver-alg-mid d-inline-block" alt="Spotless Store Online" width="220" height="220">`)


// alert("this is alert");

  const cards = [...document.querySelectorAll('.flavor-card')];

  cards.forEach((card) => {
    card.addEventListener('click', (event) => {
      console.log(`clicked ${event.currentTarget.classList}`);

      cards.map((card) => {
        if (card.dataset.active == 'true') {
          card.dataset.active = 'false';
        }
      });
      event.currentTarget.dataset.active = 'true';
    });
  });



const faqItems = document.querySelectorAll('.faq-item');

faqItems.forEach(item => {
  const question = item.querySelector('.faq-question');
  const answer = item.nextElementSibling;
  const icon = item.querySelector('i');

  item.addEventListener('click', () => {
    faqItems.forEach(otherItem => {
      if (otherItem !== item) {
        const otherAnswer = otherItem.nextElementSibling;
        const otherIcon = otherItem.querySelector('i');

        otherAnswer.classList.remove('active');
        otherIcon.classList.remove('active');
        otherAnswer.style.maxHeight = "0";
      }
    });

    answer.classList.toggle('active');
    icon.classList.toggle('active');
    if (answer.classList.contains('active')) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = "0";
    }
  });
});
  
});


  
  